// Function is used on Progressive users to format the reference number put on the report.
// The current logic is there must be a dash at the third position and the total length of the reference number
// cannot exceed 12 characters, including the dash.
const normalizeReferenceNumber = (value) => {
  if (!value) {
    return value;
  }

  // Convert to uppercase and remove spaces
  const cleanValue = value.toUpperCase().replace(/\s/g, '');

  // Handle single letter followed by 8 numbers (X-12345678)
  if (/^[A-Z][-\d]{0,10}$/.test(cleanValue)) {
    const parts = cleanValue.split('-');
    if (parts.length === 1) {
      const letter = parts[0].slice(0, 1);
      const numbers = parts[0].slice(1, 9);
      return numbers.length > 0 ? `${letter}-${numbers.slice(0, 8)}` : letter;
    }
    const letter = parts[0];
    const numbers = parts[1].slice(0, 8);
    return `${letter}-${numbers}`;
  }

  // Handle 2 letters followed by 8 numbers (XY-12345678)
  if (/^[A-Z]{2}[-\d]{0,10}$/.test(cleanValue)) {
    const parts = cleanValue.split('-');
    if (parts.length === 1) {
      const letters = parts[0].slice(0, 2);
      const numbers = parts[0].slice(2, 10);
      return numbers.length > 0 ? `${letters}-${numbers.slice(0, 8)}` : letters;
    }
    const letters = parts[0];
    const numbers = parts[1].slice(0, 8);
    return `${letters}-${numbers}`;
  }

  // Handle 3-8 numbers only
  if (/^\d{3,8}$/.test(cleanValue)) {
    return cleanValue;
  }

  // Handle numeric XX-XXXXXXX and XX-XXXXXXXXX formats
  if (/^\d{2}[-\d]{0,10}$/.test(cleanValue)) {
    const parts = cleanValue.split('-');
    if (parts.length === 1) {
      const preDash = parts[0].slice(0, 2);
      const postDash = parts[0].slice(2, 11);
      return postDash.length > 0 ? `${preDash}-${postDash}` : preDash;
    }
    return cleanValue.slice(0, 12);
  }

  // If no pattern matches, return the original value up to 12 chars
  return cleanValue.slice(0, 12);
};

export default normalizeReferenceNumber;


// WEBPACK FOOTER //
// ./src/helpers/NormalizeReferenceNumber.js